import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface SessionWarning {
	type: 'warning' | 'critical';
	message: string;
	timeRemaining: number; // in seconds
	onExtend?: () => void;
	onLogout?: () => void;
}

@Injectable({
	providedIn: 'root'
})
export class SessionWarningService {

	private warningSubject = new Subject<SessionWarning>();
	public warning$ = this.warningSubject.asObservable();

	constructor() {}

	/**
	 * Show session expiration warning
	 */
	showWarning(timeRemaining: number): void {
		const warning: SessionWarning = {
			type: timeRemaining < 300 ? 'critical' : 'warning', // 5 minutes = critical
			message: this.getWarningMessage(timeRemaining),
			timeRemaining,
			onExtend: () => {
				// This would trigger a token refresh
			},
			onLogout: () => {
				// This would trigger logout
			}
		};

		this.warningSubject.next(warning);
	}

	/**
	 * Clear any active warnings
	 */
	clearWarning(): void {
		// This could emit a special "clear" warning
	}

	private getWarningMessage(timeRemaining: number): string {
		const minutes = Math.floor(timeRemaining / 60);
		const seconds = timeRemaining % 60;

		if (minutes > 0) {
			return `Your session will expire in ${minutes} minute${minutes !== 1 ? 's' : ''}.`;
		} else {
			return `Your session will expire in ${seconds} second${seconds !== 1 ? 's' : ''}.`;
		}
	}
}
